export default __webpack_public_path__ + "static/chandan-daf0cff0a4708757cba0689f06397793.png";